// Update Dankort to allow VISA co-branded card
Cleave.CreditCardDetector.re.dankort = /^(5019|4175)\d{0,12}/;

$(function() {
  var paymentForm = $('#checkout .checkout-form');

  if (paymentForm.length === 0) {
    return;
  }

  var isDisabled = typeof $('.checkout-form').data('offline') !== 'undefined';

  var Payment = {
    CARD: 'card',
    PAYPAL: 'paypal',
  };

  var SetupType = {
    SUBSCRIPTION: 'subscription',
    BILLING: 'billing',
    CREDITS: 'credits'
  }

  var ValidCards = [
    'amex',
    'discover',
    'mastercard',
    'visa'
  ];

  // Billing info
  var billingInfo = paymentForm.find('.billing-info');
  
  // user subscription and subscription package
  var userSub = paymentForm.find('input[name=userSub]');
  var instagramUser = paymentForm.find('input[name=instagramUser]');
  var subscription = paymentForm.find('input[name=subscription]');
  var password = paymentForm.find('input[name=password]');

  // credit package
  var package = paymentForm.find('input[name=package]');

  // Unselect all
  var unselectAll = paymentForm.find('.unselect-all > a');

  // user sub list
  var updateToken = paymentForm.find('input[name=updateToken]');
  var userSubs = paymentForm.find('.user-subs');
  var userSubList = userSubs.find('.user-sub-list');
  var userSubsInput = userSubs.find('input[name=userSubs]');

  // submit button
  var submits = paymentForm.find('button[type=submit]');

  // payment cards
  var paymentMethods = paymentForm.find('.input-dropdown');
  if (paymentMethods.length > 0) {
    paymentMethods = paymentMethods.selectDropdown();
    paymentMethods.bindItems();
  }

  // card info
  if (billingInfo.length  > 0) {
    var cardNameInput = paymentForm.find('input[name=cardName]');
    var cardNumberInput = new Cleave('input[name=cardNumber]', {
      creditCard: true,
      onValueChanged: function(e) {
        var cards = $('.card-list > .card');
        if (e.target.rawValue) {
          cards.addClass('invalid');

          var type = this.properties.creditCardType;
          if (ValidCards.includes(type)) {
            // Show valid card
            cards.siblings('.card-' + type).removeClass('invalid');
          }
        } else {
          // Show all valid cards if nothing entered
          cards.removeClass('invalid')
        }
      }
    });
    var cardMonthSelect = $('select[name=cardMonth]');
    var cardYearSelect = $('select[name=cardYear]');
    var cardCodeInput = new Cleave('input[name=cardCode]', {
      numeral: true,
      numeralThousandsGroupStyle: 'none',
      numeralIntegerScale: 4,
      numeralDecimalScale: 0,
      numeralPositiveOnly: true,
      stripLeadingZeroes: false
    });

    $(cardCodeInput.element).password();
  
    // billing info
    var address1Input = $('input[name=billAddress1]');
    var address2Input = $('input[name=billAddress2]');
    var cityInput = $('input[name=billCity]');
    var stateSelect = $('select[name=billState]');
    var zipInput = $('input[name=billZip]');
    var countrySelect = $('select[name=billCountry]');
    var phoneInput = $('input[name=billPhone');

    var stateSelectDefaults = stateSelect.find('option').clone();

    countrySelect.bind('change', function(e, data) {
      var config = paymentResource.config.countries[$(this).val()];
      var parent = $(this).parent();
      var inputGroups = parent.siblings('.input-group');
      inputGroups.find('input').val('');
      inputGroups.find('select').empty();
      inputGroups.removeClass('hidden');

      for (var placeholder in config.placeholders) {
        parent.siblings('.input-group-' + placeholder).find('label > .placeholder').html(config.placeholders[placeholder]);
      }

      for (var exclude in config.excludes) {
        if (config.excludes[exclude]) {
          parent.siblings('.input-group-' + exclude).addClass('hidden');
        }
      }

      stateSelect.empty();
      stateSelect.append(stateSelectDefaults);

      for (var state in config.states) {
        var name = config.states[state];
        stateSelect.append('<option value="' + state + '">' + name + '</option>');
      }

      stateSelect.val('');

      if (data && data.setDefaults) {
        // Set defaults for the billing information
        inputGroups.each(function() {
          var inputGroup = $(this);
          if (!inputGroup.hasClass('hidden')) {
            if (inputGroup.hasClass('input-select')) {
              // Set select box default
              var select = inputGroup.find('select');
              var defaultValue = select.data('default');
              select.find('option').each(function() {
                var opt = $(this);
                if (opt.val() === defaultValue) {
                  opt.prop('selected', true);
                }
              });
            } else {
              // Set input field default
              var input = inputGroup.find('input');
              var defaultValue = input.data('default');
              if (defaultValue) {
                input.val(defaultValue);
              }
            }
          }
        });        
      }
    });

    if (countrySelect.val()) {
      countrySelect.trigger('change', [{
        setDefaults: true
      }]);
    }
  }

  // validation
  var requiredInputs = paymentForm.find('input[required], select[required]');

  var validate = function(setupType) {
    var valid = true;
    paymentForm.find('.invalid > input, .required > input').each(function() {
      $(this).setValid();
    });

    var names = cardNameInput.val().split(' ');
    if (names.length < 2) {
      valid = false;
      cardNameInput.setInvalid();
    }

    if (setupType === SetupType.BILLING && !userSubsInput.is(':checked')) {
      valid = false;
      userSubList.setInvalid();
    }
    
    if (!$.payform.validateCardNumber(cardNumberInput.getRawValue())) {
      valid = false;
      $(cardNumberInput.element).setInvalid();
    }

    if (!ValidCards.includes(cardNumberInput.properties.creditCardType)) {
      valid = false;
      $(cardNumberInput.element).setInvalid();
    }

    if (!$.payform.validateCardCVC(cardCodeInput.getRawValue(), cardNumberInput.properties.creditCardType)) {
      valid = false;
      $(cardCodeInput.element).setInvalid();
    }

    requiredInputs.each(function() {
      var requiredInput = $(this);
      var parent = requiredInput.parent();
      if (!(requiredInput.val() || parent.hasClass('hidden'))) {
        valid = false;
        requiredInput.setRequired();
      }
    });

    return valid;
  }

  userSubsInput.bind('change', function() {
    if (userSubsInput.is(':checked')) {
      userSubList.setValid();
    } else {
      userSubList.setInvalid();
    }
  });

  requiredInputs.bind('change keyup input', function() {
    $(this).setValid();
  });

  unselectAll.on('click.unselectAll', function(e) {
    e.preventDefault();

    var target = $(this).data('target');

    paymentForm.find('input[name=' + target + ']').prop('checked', false);
    userSubsInput.trigger('change');
  })

  var onSubmit = function(event) {
    event.preventDefault();

    var submit = $(this);
    var payment = submit.data('payment');
    var saved = submit.data('saved');
    var setupType = submit.data('setup');

    var billingId;
    if (payment === Payment.CARD) {
      if (saved) {
        billingId = paymentForm.find('input[name=billingId]').val();
      } else if (!validate(setupType)) {
        return false;
      }
    }

    submits.prop('disabled', true);
    submit.addClass('btn-loading');

    recaptchaResource.execute(function(token) {
      var setup;
      var data;
      var headers;
      if (setupType === SetupType.SUBSCRIPTION) {
        setup = paymentResource.setupSubscription;
        data = {
          recaptchaToken: token,
          subscription: subscription.val(),
          password: password.val(),
          userSub: userSub.val(),
          instagramUser: instagramUser.val(),
          billingId: billingId
        };
      } else if (setupType === SetupType.BILLING) {
        setup = paymentResource.setupBillingUpdate;
        if (updateToken.val()) {
          headers = {
              'Authorization': 'Bearer ' + updateToken.val()
          }
        }
        var userSubIds = [];
        paymentForm.find('input[name=userSubs]:checked').each(function() {
          userSubIds.push($(this).val())
        });
        data = {
          recaptchaToken: token,
          userSubs: userSubIds,
          billingId: billingId
        };
      } else if (setupType === SetupType.CREDITS) {
        setup = paymentResource.setupCreditsPayment;
        data = {
          recaptchaToken: token,
          package: package.val(),
          billingId: billingId
        };
      } else {
        throw new Error('Invalid setup');
      }

      var billingData;
      if (payment === Payment.CARD && !saved) {
        var firstName;
        var lastName;
        
        var names = cardNameInput.val().split(' ');
        if (names.length >= 2) {
          firstName = names[0];
          lastName = names.slice(1).join(' ')
        }

        var country = countrySelect.val();
        var countryConfig = paymentResource.config.countries[country];

        billingData = {
          cardNumber: cardNumberInput.getRawValue(),
          cardMonth: cardMonthSelect.val(),
          cardYear: cardYearSelect.val(),
          cardCode: cardCodeInput.getRawValue(),
          firstName: firstName,
          lastName: lastName,
          address1: address1Input.val(),
          address2: address2Input.val(),
          city: cityInput.val(),
          state: stateSelect.val(),
          phone: phoneInput.val(),
          zip: countryConfig.excludes && countryConfig.excludes.zip ? '00000' : zipInput.val(),
          country: country
        };
      }
  
      setup(payment, data, {
        success: function(resp) {
          if (resp.formUrl) {
            nmiResource.submit(resp.formUrl, billingData)
          } else if (resp.redirectUrl) {
            // Just redirect the user
            window.location.href = resp.redirectUrl;
          }
        },
        error: function(xhr, status, err) {
          var json = xhr.responseJSON;
          if (json) {
            var input;
            if (json.validation && Array.isArray(json.validation.keys)) {
              var key = json.validation.keys[0];
              input = paymentForm.find('input[name=' + key + ']');
            }

            if (input && xhr.status === 409) {
              input.setConflict();
            } else if (input && xhr.status === 400) {
              input.setInvalid();
            } else {
              AVNotify(json.message || err, 'danger');
            }
          } else {
            AVNotify(err, 'danger');
          }

          submits.prop('disabled', false);
          submit.removeClass('btn-loading');
          recaptchaResource.reset();
        },
        headers: headers
      });
    });
  };

  submits.prop('disabled', false);
  submits.removeClass('btn-loading');
  submits.on('click', onSubmit);

  if(isDisabled) {
    submits.prop('disabled', true);
  }

});
